import type { SVGProps } from 'react';
const DawnFlagIN = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-IN_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-IN_svg__a)">
      <path fill="#FFA44A" d="M0 5.333h22V0H0z" />
      <path fill="#1A9F0B" d="M0 16h22v-5.333H0z" />
      <path
        fill="#181A93"
        fillOpacity={0.15}
        d="M11 9.6c.868 0 1.572-.716 1.572-1.6S11.868 6.4 11 6.4 9.43 7.116 9.43 8 10.132 9.6 11 9.6"
      />
      <path
        fill="#181A93"
        d="M13.238 8c0 1.24-.99 2.267-2.238 2.267S8.762 9.24 8.762 8 9.752 5.733 11 5.733 13.238 6.76 13.238 8m-.667 0c0 .884-.703 1.6-1.571 1.6S9.428 8.884 9.428 8 10.132 6.4 11 6.4s1.571.716 1.571 1.6"
      />
      <path
        fill="#181A93"
        d="M11 8.533c.29 0 .524-.239.524-.533A.53.53 0 0 0 11 7.467a.53.53 0 0 0-.523.533c0 .294.234.533.523.533"
      />
    </g>
  </svg>
);
export default DawnFlagIN;
